export const VALIDATED_ACTION_PAYLOAD = { action: 'validated_action' };
export const REFUSED_ACTION_PAYLOAD = { action: 'refused_action' };

export const DEMAND_PENDING_VALIDATION = 'pending_validation';
export const DEMAND_VALIDATED = 'validated';
export const DEMAND_REFUSED = 'refused';
